module.exports = {
  kUrl: Symbol('url'),
  kWriting: Symbol('writing'),
  kResuming: Symbol('resuming'),
  kQueue: Symbol('queue'),
  kConnect: Symbol('connect'),
  kResume: Symbol('resume'),
  kPause: Symbol('pause'),
  kSocketTimeout: Symbol('socket timeout'),
  kIdleTimeout: Symbol('idle timeout'),
  kKeepAliveMaxTimeout: Symbol('max keep alive timeout'),
  kKeepAliveTimeoutThreshold: Symbol('keep alive timeout threshold'),
  kKeepAliveTimeout: Symbol('keep alive timeout'),
  kKeepAlive: Symbol('keep alive'),
  kTLSServerName: Symbol('server name'),
  kHost: Symbol('host'),
  kTLSOpts: Symbol('TLS Options'),
  kClosed: Symbol('closed'),
  kNeedDrain: Symbol('need drain'),
  kReset: Symbol('reset'),
  kDestroyed: Symbol('destroyed'),
  kMaxHeadersSize: Symbol('max headers size'),
  kHeadersTimeout: Symbol('headers timeout'),
  kRunningIdx: Symbol('running index'),
  kPendingIdx: Symbol('pending index'),
  kError: Symbol('error'),
  kClient: Symbol('client'),
  kParser: Symbol('parser'),
  kOnDestroyed: Symbol('destroy callbacks'),
  kPipelining: Symbol('pipelinig'),
  kRetryDelay: Symbol('retry delay'),
  kSocketPath: Symbol('socket path'),
  kSocket: Symbol('socket'),
  kRetryTimeout: Symbol('retry timeout'),
  kTLSSession: Symbol('tls session cache')
}
